module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "checklist-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-breadcrumb', {
    staticClass: "breadCrumb",
    attrs: {
      "items": _vm.breadCrumbItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-chklst-dup",
      modifiers: {
        "confirm-chklst-dup": true
      }
    }],
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("\n          Duplicate\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveChecklist()
      }
    }
  }, [_vm._v("\n          Save\n        ")]), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.confirm-chklst-del",
      modifiers: {
        "confirm-chklst-del": true
      }
    }],
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("\n          Delete whole Checklist\n        ")])], 1)]), _vm._v(" "), (_vm.duplicate) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-chklst-dup",
      "title": "Duplicate Checklist",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.duplicateChecklist(true)
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("This action will duplicate the entire content of this checklist."), _c('br'), _vm._v("Do you want to proceed?")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "confirm-chklst-del",
      "title": "Delete Checklist",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        return _vm.deleteChecklist()
      }
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Are you sure you want to delete the whole checklist")])]), _vm._v(" "), _c('h2', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "basic-info-wrapper"
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.name) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(1), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-7",
    attrs: {
      "type": "text",
      "placeholder": _vm.formData.name ? '' : 'Enter checklist title',
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('thumbnail', {
    attrs: {
      "picture": _vm.formData.picture,
      "picture_url": _vm.formData.picture_url
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "picture_url", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.role) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(3), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-3",
    attrs: {
      "options": _vm.userRoles,
      "value-field": "id",
      "text-field": "name"
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row separator mt-2"
  }, [_vm._m(4), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "suggest": _vm.suggestArea,
      "anchor": "name",
      "process": _vm.processJSON,
      "on-select": _vm.getDataSearchArea
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('b-button', {
    staticClass: " work-areas__btn",
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.areaFromList = !_vm.areaFromList
      }
    }
  }, [_vm._v("Or select from list\n          ")])], 1), _vm._v(" "), (_vm.areaFromList) ? _c('div', {
    staticClass: "col-md-2 offset-md-1"
  }, [_c('div', {
    staticClass: " work-areas__area-checkbox"
  }, [_c('area-checkbox', {
    attrs: {
      "type": "radio",
      "areas": _vm.areas,
      "baseId": 'areaCheckbox',
      "selected": _vm.formData.area
    },
    on: {
      "selectedAreaChanged": function($event) {}
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.area.length) ? 'has-danger' : '', 'line']
  }, [_vm._m(5), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "selected-areas"
  }, _vm._l((_vm.formData.area), function(item) {
    return _c('p', [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.formData.double_signature_required),
      callback: function($$v) {
        _vm.$set(_vm.formData, "double_signature_required", $$v)
      },
      expression: "formData.double_signature_required"
    }
  })], 1), _vm._v(" "), (!_vm.formData.id) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveChecklist()
      }
    }
  }, [_vm._v("\n        Save and continue\n      ")]) : _vm._e()], 1), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-3",
    on: {
      "click": function($event) {
        _vm.showTasks = !_vm.showTasks
      }
    }
  }, [_c('b', [_vm._v("Checklist items")])])]) : _vm._e(), _vm._v(" "), (_vm.formData.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('p', {
    staticClass: "checklist-items-wrapper",
    attrs: {
      "id": "collapse-checklists"
    }
  }, [_c('b-list-group', [(!_vm.formData.tasks.length) ? _c('b-list-group-item', {
    staticClass: "list-group-checklist-item"
  }, [_vm._v("\n              There are no questions in this checklist yet\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('b-list-group-item', {
      key: index,
      staticClass: "list-group-checklist-item draggable",
      attrs: {
        "active": index === _vm.activeTask,
        "draggable": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.activeTaskNext = index
        },
        "drop": function($event) {
          return _vm.handleDrop($event, index)
        },
        "dragstart": function($event) {
          return _vm.handleDragStart($event, item, index)
        },
        "dragend": function($event) {
          return _vm.handleDragEnd($event, item, index)
        },
        "dragover": function($event) {
          return _vm.handleDragOver($event, index)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  })], 2)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "",
      "variant": "primary"
    },
    on: {
      "click": _vm.addEmptyTask
    }
  }, [_vm._v("+ Add one more checklist item")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, _vm._l((_vm.formData.tasks), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTask === index),
        expression: "activeTask === index"
      }],
      staticClass: "checklist-item-wrapper"
    }, [_c('h2', [_vm._v("Checklist item information")]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.name) ? 'has-danger' : '', 'row basic-info__title']
    }, [_vm._m(7, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "col-md-9 form-control",
      attrs: {
        "type": "text",
        "placeholder": "Enter task title",
        "maxlength": "255"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeChecklistTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.description) ? 'has-danger' : '', 'row']
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: "col-md-10 basic-info__description form-control",
      attrs: {
        "placeholder": "Enter description"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "change": function($event) {
          return _vm.onChangeChecklistTask()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row mt-1"
    }, [_c('p', {
      staticClass: "col-md-3"
    }, [_c('b', [_vm._v("Upload\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'image'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'image'
        }
      }
    }, [_vm._v("photo")]), _vm._v("\n              or\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'video'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'video'
        }
      }
    }, [_vm._v("video")]), _vm._v("\n              for this checklist item")]), _vm._v(" (if none, default icon will be used)")]), _vm._v(" "), (item.selectedContent == 'image') ? _c('thumbnail', {
      attrs: {
        "picture": item.picture,
        "picture_url": item.picture_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "picture", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "picture_url", $event)
        },
        "change": function($event) {
          return _vm.onChangeChecklistTask()
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.selectedContent == 'video'),
        expression: "item.selectedContent == 'video'"
      }],
      class: [(item.video_require) ? 'has-danger' : ''],
      attrs: {
        "id": ""
      }
    }, [_c('div', {
      class: [(item.video_require) ? 'form-control' : '']
    }, [_c('thumbnail', {
      attrs: {
        "picture": item.video_thumbnail,
        "picture_url": item.thumbnail_url
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "video_thumbnail", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "thumbnail_url", $event)
        }
      }
    }), _vm._v(" "), _c('b-form-file', {
      ref: "checklistItemVideoFile",
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "accept": ".mp4, .mov",
        "choose-label": (!item.video && !item.video_url) ? 'Choose video' : 'Remove video',
        "placeholder": item.video_url
      },
      on: {
        "change": function($event) {
          return _vm.handleVideoFileChange($event)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clearChecklistItemVideo($event, item, index)
        }
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)])], 1), _vm._v(" "), _c('div', {
      staticClass: "instructions"
    }, [_c('h2', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("Enter instructions for the task that will appear in the app for this task. If left blank no instructions for this task will be shown.")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('b-form-file', {
      ref: 'pdffile' + index,
      refInFor: true,
      attrs: {
        "placeholder": item.description_file_url,
        "choose-label": (!item.description_file && !item.description_file_url) ? 'Choose PDF file' : 'Remove PDF file',
        "accept": ".pdf"
      },
      nativeOn: {
        "click": function($event) {
          _vm.clearPdfFile($event, index);
          (item.description_file) ? _vm.onChangeChecklistTask(): '';
        },
        "change": function($event) {
          _vm.onChangeChecklistTask();
          _vm.changePdfFile($event, index);
        }
      },
      model: {
        value: (item.description_file),
        callback: function($$v) {
          _vm.$set(item, "description_file", $$v)
        },
        expression: "item.description_file"
      }
    })], 1)]), _vm._v(" "), (!item.steps.length) ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((!item.description_file && !item.description_file_url)),
        expression: "(!item.description_file && !item.description_file_url)"
      }],
      staticClass: "instructions__step"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          _vm.addEmptyStep(item);
          _vm.onChangeChecklistTask();
        }
      }
    }, [_vm._v("Add steps")])], 1)])])])] : _vm._e(), _vm._v(" "), _vm._l((item.steps), function(step, index) {
      return [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: ((!item.description_file && !item.description_file_url)),
          expression: "(!item.description_file && !item.description_file_url)"
        }],
        staticClass: "instructions__step"
      }, [_c('div', {
        staticClass: "row align-items-baseline"
      }, [_vm._m(10, true), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('div', {
        class: [(!step.valid) ? 'has-danger' : '', 'col-md-1']
      }, [_c('b-form-input', {
        staticStyle: {
          "width": "55px"
        },
        attrs: {
          "type": "number"
        },
        on: {
          "change": function($event) {
            _vm.validateSteps(item);
            _vm.onChangeChecklistTask();
          }
        },
        model: {
          value: (step.order),
          callback: function($$v) {
            _vm.$set(step, "order", $$v)
          },
          expression: "step.order"
        }
      })], 1), _vm._v(" "), _c('p', {
        staticClass: "col-md-5 offset-md-3"
      }, [_c('b', [_vm._v("Attach\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'image'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'image'
          }
        }
      }, [_vm._v("photo")]), _vm._v("\n                    or\n                    "), _c('span', {
        staticClass: "underline pointer image-video",
        class: {
          'image-video_active': step.selectedContent == 'video'
        },
        on: {
          "click": function($event) {
            step.selectedContent = 'video'
          }
        }
      }, [_vm._v("video")])])])]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [(!step.valid) ? _c('div', {
        staticClass: "col-md-5 offset-md-3",
        staticStyle: {
          "color": "red"
        }
      }, [_vm._v("\n                    Please enter a number that is not used\n                  ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-md-7"
      }, [_c('span', {
        class: [(_vm.needFill && !step.description) ? 'has-danger' : '']
      }, [_c('textarea', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (step.description),
          expression: "step.description"
        }],
        staticClass: " instructions__step-text form-control",
        attrs: {
          "placeholder": "Enter step description"
        },
        domProps: {
          "value": (step.description)
        },
        on: {
          "change": function($event) {
            return _vm.onChangeChecklistTask();
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(step, "description", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "instructions__step-buttons"
      }, [(index == item.steps.length - 1) ? _c('b-button', {
        attrs: {
          "variant": "primary"
        },
        on: {
          "click": function($event) {
            _vm.addEmptyStep(item);
            _vm.onChangeChecklistTask();
          }
        }
      }, [_vm._v("Add one more step")]) : _vm._e(), _vm._v(" "), (index != item.steps.length - 1) ? _c('div') : _vm._e(), _vm._v(" "), (item.steps.length) ? _c('b-button', {
        attrs: {
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeStep(item, index);
            _vm.onChangeChecklistTask();
          }
        }
      }, [_vm._v("Remove this step")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
        staticClass: "col-md-5"
      }, [(step.selectedContent == 'image') ? _c('thumbnail', {
        attrs: {
          "picture": step.picture,
          "picture_url": step.picture_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "picture", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "picture_url", $event)
          },
          "change": function($event) {
            return _vm.onChangeChecklistTask()
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (step.selectedContent == 'video'),
          expression: "step.selectedContent == 'video'"
        }],
        class: [(step.video_require) ? 'has-danger' : ''],
        attrs: {
          "id": ""
        }
      }, [_c('div', {
        staticClass: "row ",
        class: [(step.video_require) ? 'form-control' : '']
      }, [_c('thumbnail', {
        attrs: {
          "picture": step.video_thumbnail,
          "picture_url": step.thumbnail_url
        },
        on: {
          "update:picture": function($event) {
            return _vm.$set(step, "video_thumbnail", $event)
          },
          "update:picture_url": function($event) {
            return _vm.$set(step, "thumbnail_url", $event)
          }
        }
      }), _vm._v(" "), _c('b-form-file', {
        ref: "stepvideofile",
        refInFor: true,
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "accept": ".mp4, .mov",
          "choose-label": (!step.video && !step.video_url) ? 'Choose video' : 'Remove video',
          "placeholder": step.video_url
        },
        on: {
          "change": function($event) {
            return _vm.handleVideoFileChange($event)
          }
        },
        nativeOn: {
          "click": function($event) {
            return _vm.clearStepVideo($event, step, index)
          }
        },
        model: {
          value: (step.video),
          callback: function($$v) {
            _vm.$set(step, "video", $$v)
          },
          expression: "step.video"
        }
      })], 1)])], 1)])])]
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "instructions__step-buttons"
    }, [_c('b-button', {
      attrs: {
        "variant": "success"
      },
      on: {
        "click": function($event) {
          return _vm.saveTask(item)
        }
      }
    }, [_vm._v("Save this checklist item")]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTask(item, index)
        }
      }
    }, [_vm._v("Delete this checklist item")])], 1)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "leavingItemConfirm",
    attrs: {
      "title": ""
    }
  }, [_vm._v("\n      You have unsaved changes in this item. You want to:\n      "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-btn', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.saveTask(_vm.formData.tasks[_vm.activeTask]);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        _vm.discardTaskChanges(_vm.activeTask);
        _vm.$refs.leavingItemConfirm.hide();
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$refs.leavingItemConfirm.hide();
        _vm.activeTaskNext = null;
      }
    }
  }, [_vm._v("Return to this item")])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 duplicat-warning"
  }, [_c('p', [_vm._v("Details are copied from the original. If you don't make any changes and save, the item will be duplicated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Checklist title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('b', [_vm._v("Upload main checklist image")]), _vm._v(" (if none, default icon will be used)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Assign to user role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2 align-baseline"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Requires two signatures")]), _vm._v(" (one signature of the user and one from somebody else e.g. manager)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('p', {
    staticClass: "col-md-2 mt-1"
  }, [_c('b', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_vm._v("OR "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("upload a PDF file with task instructions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Step")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Order")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b9fb52c","hasScoped":true}!./src/components/checklistConfig/checklistConfig.component.html
// module id = 538
// module chunks = 1